"use client";

import type { LucideIcon } from "lucide-react";
import type * as TogglePrimitive from "@radix-ui/react-toggle";
import type { VariantProps } from "class-variance-authority";
import * as React from "react";

import { Toggle, toggleVariants } from "./Toggle";

interface IconToggleProps
  extends
    React.ComponentProps<typeof TogglePrimitive.Root>,
    VariantProps<typeof toggleVariants> {
  icon: LucideIcon;
}

function IconToggle({
  icon: Icon,
  variant = "ghost",
  size = "icon",
  ...props
}: IconToggleProps): React.JSX.Element {
  return (
    <Toggle variant={variant} size={size} {...props}>
      <Icon />
    </Toggle>
  );
}

export { IconToggle };
